import { manageError, manageResponse } from './api-util'
import { http } from './http'
import { AttachmentProps } from '@/@types/attachment'
import { SignatureUserProps } from '@/@types/global'
import { TemplateProps } from '@/@types/template'

const getUsers = async () => {
  try {
    const response: MyResponse<any[]> = await http.get('users', {})
    return manageResponse(response)
  } catch (error) {
    manageError(error)
  }
}

const getFile = async (path: string): Promise<string | void> => {
  try {
    const response = await http.get(`/file?path=${encodeURIComponent(path)}`)
    return manageResponse(response) as string
  } catch (error) {
    manageError(error)
  }
}

const getAttachment = async (data: {
  idUser: number
}): Promise<AttachmentProps | void> => {
  try {
    const response = await http.get(`/attachment?idUser=${data.idUser}`)
    return manageResponse(response) as AttachmentProps
  } catch (error) {
    manageError(error)
  }
}

const getTemplate = async (data: { id: string }): Promise<TemplateProps> => {
  try {
    const response = await http.get(`/generate-report-template?id=${data.id}`)
    return manageResponse(response) as TemplateProps
  } catch (error) {
    manageError(error)
    return {} as TemplateProps
  }
}

const getSignatureUser = async (data: {
  email: string
}): Promise<SignatureUserProps> => {
  try {
    const response = await http.get(`/signature-user?email=${data.email}`)
    return manageResponse(response) as SignatureUserProps
  } catch (error) {
    manageError(error)
    return {} as SignatureUserProps
  }
}

export {
  getUsers,
  getFile,
  getAttachment,
  getTemplate,
  getSignatureUser,
  loadFile,
}
